// extracted by mini-css-extract-plugin
export default {"counter":"Counter_counter__39-Lw","value":"Counter_value__+CAXq","actions":"Counter_actions__r0Xfu"};